import { UsersSection } from '@/features/users/users-section';

// Ports app/[brand]/admin/users/page.tsx. Rendered inside the admin <Shell> by
// admin-app.tsx, so this exports the section content only.
export function Users() {
  return <UsersSection />;
}
